var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 11.082C9.85081 11.082 11.082 9.85081 11.082 8.33203C11.082 6.81325 9.85081 5.58203 8.33203 5.58203C6.81325 5.58203 5.58203 6.81325 5.58203 8.33203C5.58203 9.85081 6.81325 11.082 8.33203 11.082Z",
    stroke: "url(#paint0_linear_721_19549)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 1C6.38841 1 4.52315 1.77262 3.14788 3.14788C1.77262 4.52315 1 6.38841 1 8.33333C1 10.0677 1.3685 11.2025 2.375 12.4583L8.33333 19.3333L14.2917 12.4583C15.2982 11.2025 15.6667 10.0677 15.6667 8.33333C15.6667 6.38841 14.894 4.52315 13.5188 3.14788C12.1435 1.77262 10.2783 1 8.33333 1V1Z",
    stroke: "url(#paint1_linear_721_19549)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_721_19549",
    x1: 10.7926,
    y1: 11.082,
    x2: 4.76223,
    y2: 8.31212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8264F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_721_19549",
    x1: 14.8947,
    y1: 19.3333,
    x2: -2.26224,
    y2: 13.0288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8264F9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLogo);
export default __webpack_public_path__ + "static/media/pinLogo.53bbe6ec7e81c9f7942a33b07f6b64ed.svg";
export { ForwardRef as ReactComponent };